const EventModel = {
  id: null,
  userId: "",
  eventName: null,
  eventDescription: null,
  eventStatusId: null,
  eventCategoryTypeId: null,
  countryId: null,
  street1: null,
  street2: null,
  city: null,
  stateId: null,
  zip: null,
  startDate: null,
  startTime: null,
  startTimeStr: null,
  endDate: null,
  endTime: null,
  endTimeStr: null,
  timeZoneId: null,
  currencyId: null,
  coverPicWide: null,
  coverPicWideUrl: null,
  coverPicSquare: null,
  parkingInstructions: null,
  healthSafetyInfo: null,
  pitchAllocationType: null,
  publishedDate: null,
  publishedStatus: null,
  countryName: null,
  currencyName: null,
  eventCategoryTypeName: null,
  eventStatusName: null,
  stateName: null,
  eventDecription: null,
  url: null,
};

export default EventModel;
